/* =========================================================
   YOUNG FOUNDER TOOLKIT — Pathly Parenting
   Vanilla JS. No dependencies.
   ========================================================= */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Shopify product form controls */
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var quantity = form.querySelector('input[name="quantity"]');
    var variantSelect = form.querySelector('[data-variant-select]');
    var price = form.closest('.hero-buy-card') && form.closest('.hero-buy-card').querySelector('[data-product-price]');
    var availability = form.querySelector('[data-product-availability]');
    var gallery = form.closest('.hero-buy-card') && form.closest('.hero-buy-card').querySelector('[data-product-gallery]');
    var mainImage = gallery && gallery.querySelector('[data-product-main-image]');

    form.querySelector('[data-qty-minus]')?.addEventListener('click', function () {
      quantity.value = String(Math.max(1, Number(quantity.value || 1) - 1));
    });
    form.querySelector('[data-qty-plus]')?.addEventListener('click', function () {
      quantity.value = String(Math.max(1, Number(quantity.value || 1) + 1));
    });

    if (variantSelect) {
      variantSelect.addEventListener('change', function () {
        var option = variantSelect.options[variantSelect.selectedIndex];
        var available = option.dataset.available === 'true';
        if (price && option.dataset.price) price.textContent = option.dataset.price;
        if (mainImage && option.dataset.image) {
          mainImage.srcset = option.dataset.image + ' 1000w';
          mainImage.sizes = '100vw';
          mainImage.setAttribute('src', option.dataset.image);
        }
        if (availability) {
          availability.classList.toggle('is-sold-out', !available);
          availability.innerHTML = available
            ? '<svg aria-hidden="true"><use href="#i-check"></use></svg> In stock and ready to order'
            : 'Currently sold out';
        }
      });
    }
  });

  document.querySelectorAll('[data-product-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var gallery = thumb.closest('[data-product-gallery]');
      var image = gallery && gallery.querySelector('[data-product-main-image]');
      if (!image) return;
      var selectedImage = thumb.dataset.image;
      image.srcset = selectedImage + ' 1000w';
      image.sizes = '100vw';
      image.setAttribute('src', selectedImage);
      image.alt = thumb.dataset.alt || image.alt;
      gallery.querySelectorAll('[data-product-thumb]').forEach(function (item) {
        item.classList.toggle('is-active', item === thumb);
      });
    });
  });

  /* -------------------------------------------------------
     1. TRACKING HOOKS
     Fires Meta Pixel (fbq) when present, pushes to dataLayer
     when present, and always emits a DOM CustomEvent so you
     can bind any other tool. No IDs are hard-coded here —
     add your Pixel ID in index.html.
     ------------------------------------------------------- */
  function track(eventName, params) {
    var data = params || {};
    try { if (typeof window.fbq === 'function') window.fbq('track', eventName, data); } catch (e) {}
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: eventName }, data));
    } catch (e) {}
    document.dispatchEvent(new CustomEvent('pathly:' + eventName, { detail: data }));
  }

  var page = document.querySelector('.pathly-page');
  var PRODUCT = {
    content_name: (page && page.dataset.productTitle) || 'Young Founder Toolkit',
    content_ids: page && page.dataset.productId ? [page.dataset.productId] : [],
    content_type: 'product',
    content_category: 'Educational Activity Kit',
    currency: (page && page.dataset.shopCurrency) || 'PKR',
    value: Number((page && page.dataset.productPrice) || 0)
  };

  // Exposed so a thank-you page or checkout callback can fire the final event.
  window.PathlyTrack = {
    track: track,
    purchaseComplete: function (extra) {
      track('Purchase', Object.assign({}, PRODUCT, extra || {}));
    }
  };

  // ViewContent — once, on load
  track('ViewContent', PRODUCT);

  // InitiateCheckout — any purchase button
  document.addEventListener('click', function (e) {
    var checkout = e.target.closest('[data-track-checkout]');
    if (checkout) {
      track('InitiateCheckout', Object.assign({}, PRODUCT, {
        cta_location: checkout.getAttribute('data-cta') || 'unknown'
      }));
    }
    var wa = e.target.closest('[data-track-whatsapp]');
    if (wa) {
      track('Contact', {
        channel: 'whatsapp',
        cta_location: wa.getAttribute('data-cta') || 'unknown'
      });
      document.dispatchEvent(new CustomEvent('pathly:ContactWhatsApp'));
    }
  });

  // ScrollDepth — 25 / 50 / 75 / 100
  (function scrollDepth() {
    var marks = [25, 50, 75, 100];
    var fired = {};
    var ticking = false;

    function check() {
      ticking = false;
      var doc = document.documentElement;
      var max = doc.scrollHeight - window.innerHeight;
      if (max <= 0) return;
      var pct = Math.min(100, Math.round(((window.scrollY || doc.scrollTop) / max) * 100));
      marks.forEach(function (m) {
        if (pct >= m && !fired[m]) {
          fired[m] = true;
          track('ScrollDepth', { percent: m });
        }
      });
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(check); }
    }, { passive: true });
    check();
  })();

  /* -------------------------------------------------------
     2. IMAGE PLACEHOLDER HANDLING
     Product images are shown only once they load successfully.
     Until real files exist at the paths in index.html, the
     drawn placeholder frame underneath stays visible.
     ------------------------------------------------------- */
  document.querySelectorAll('.mock img').forEach(function (img) {
    function loaded() { img.classList.add('is-loaded'); }
    if (img.complete && img.naturalWidth > 0) loaded();
    else img.addEventListener('load', loaded);
  });

  // Logo: fall back to a styled wordmark if the file is missing
  document.querySelectorAll('.brand-logo[data-fallback="text"]').forEach(function (logo) {
    function markMissing() {
      var holder = logo.closest('.brand') || logo.closest('.footer-brand');
      if (holder) holder.classList.add('logo-missing');
    }
    if (logo.complete && logo.naturalWidth === 0) markMissing();
    logo.addEventListener('error', markMissing);
  });

  /* -------------------------------------------------------
     3. MOBILE MENU
     ------------------------------------------------------- */
  var toggle = document.querySelector('.nav-toggle');
  var menu = document.getElementById('mobile-menu');

  if (toggle && menu) {
    toggle.addEventListener('click', function () {
      var open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      toggle.setAttribute('aria-label', open ? 'Open menu' : 'Close menu');
      menu.hidden = open;
    });
    menu.addEventListener('click', function (e) {
      if (e.target.tagName === 'A') {
        toggle.setAttribute('aria-expanded', 'false');
        toggle.setAttribute('aria-label', 'Open menu');
        menu.hidden = true;
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !menu.hidden) {
        toggle.setAttribute('aria-expanded', 'false');
        menu.hidden = true;
        toggle.focus();
      }
    });
  }

  /* -------------------------------------------------------
     4. SMOOTH SCROLL WITH STICKY-HEADER OFFSET
     ------------------------------------------------------- */
  document.querySelectorAll('a[href^="#"]').forEach(function (link) {
    link.addEventListener('click', function (e) {
      var id = link.getAttribute('href');
      if (!id || id === '#') return;
      var target = document.querySelector(id);
      if (!target) return;
      e.preventDefault();
      var nav = document.getElementById('nav');
      var offset = (nav && getComputedStyle(nav).position === 'sticky') ? nav.offsetHeight + 12 : 12;
      var top = target.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top: top, behavior: reduceMotion ? 'auto' : 'smooth' });
      // keep keyboard focus with the visual jump
      target.setAttribute('tabindex', '-1');
      target.focus({ preventScroll: true });
    });
  });

  /* -------------------------------------------------------
     5. FAQ ACCORDION (accessible, multiple can stay open)
     ------------------------------------------------------- */
  var faqButtons = Array.prototype.slice.call(document.querySelectorAll('.faq-q'));

  faqButtons.forEach(function (btn, i) {
    var panel = document.getElementById(btn.getAttribute('aria-controls'));

    btn.addEventListener('click', function () {
      var open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!open));
      if (panel) panel.hidden = open;
      if (!open) track('FAQOpen', { question: btn.textContent.trim() });
    });

    // Arrow-key navigation between questions
    btn.addEventListener('keydown', function (e) {
      var next;
      if (e.key === 'ArrowDown') next = faqButtons[i + 1];
      else if (e.key === 'ArrowUp') next = faqButtons[i - 1];
      else if (e.key === 'Home') next = faqButtons[0];
      else if (e.key === 'End') next = faqButtons[faqButtons.length - 1];
      if (next) { e.preventDefault(); next.focus(); }
    });
  });

  /* -------------------------------------------------------
     6. PRODUCT GALLERY + LIGHTBOX
     ------------------------------------------------------- */
  var galItems = Array.prototype.slice.call(document.querySelectorAll('.gal-item'));
  var lightbox = document.getElementById('lightbox');
  var lbImage = document.getElementById('lbImage');
  var lbCaption = document.getElementById('lbCaption');
  var lbClose = lightbox && lightbox.querySelector('.lb-close');
  var lbPrev = lightbox && lightbox.querySelector('.lb-prev');
  var lbNext = lightbox && lightbox.querySelector('.lb-next');
  var lastFocused = null;
  var current = 0;

  function show(index) {
    if (!galItems.length) return;
    current = (index + galItems.length) % galItems.length;
    var item = galItems[current];
    var img = item.querySelector('img');
    var src = item.getAttribute('data-full') || (img && img.getAttribute('src')) || '';
    lightbox.classList.remove('lb-missing');
    lbImage.src = src;
    lbImage.alt = (img && img.getAttribute('alt')) || '';
    lbCaption.textContent = item.getAttribute('data-caption') || '';
    // Until the real photograph exists at that path, say so plainly
    lbImage.onerror = function () {
      lightbox.classList.add('lb-missing');
      lbCaption.textContent = 'Image not uploaded yet — expected file: ' + src;
    };
  }

  function openLightbox(index) {
    if (!lightbox) return;
    lastFocused = document.activeElement;
    show(index);
    lightbox.hidden = false;
    document.body.style.overflow = 'hidden';
    lbClose.focus();
    track('ViewProductGallery', {
      content_name: PRODUCT.content_name,
      image: lbCaption.textContent
    });
  }

  function closeLightbox() {
    if (!lightbox) return;
    lightbox.hidden = true;
    lbImage.src = '';
    document.body.style.overflow = '';
    if (lastFocused) lastFocused.focus();
  }

  galItems.forEach(function (item, i) {
    item.addEventListener('click', function () { openLightbox(i); });
  });

  if (lightbox) {
    lbClose.addEventListener('click', closeLightbox);
    lbPrev.addEventListener('click', function () { show(current - 1); });
    lbNext.addEventListener('click', function () { show(current + 1); });
    lightbox.addEventListener('click', function (e) {
      if (e.target === lightbox) closeLightbox();
    });
    document.addEventListener('keydown', function (e) {
      if (lightbox.hidden) return;
      if (e.key === 'Escape') closeLightbox();
      if (e.key === 'ArrowLeft') show(current - 1);
      if (e.key === 'ArrowRight') show(current + 1);
      if (e.key === 'Tab') {
        // simple focus trap across the three controls
        var focusables = [lbPrev, lbNext, lbClose];
        var idx = focusables.indexOf(document.activeElement);
        e.preventDefault();
        var step = e.shiftKey ? -1 : 1;
        focusables[(Math.max(idx, 0) + step + focusables.length) % focusables.length].focus();
      }
    });
  }

  // Fire ViewProductGallery once when the gallery scrolls into view too
  var galleryEl = document.getElementById('gallery');
  if (galleryEl && 'IntersectionObserver' in window) {
    var galSeen = false;
    var galObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && !galSeen) {
          galSeen = true;
          track('ViewProductGallery', { trigger: 'scroll_into_view' });
          galObs.disconnect();
        }
      });
    }, { threshold: 0.3 });
    galObs.observe(galleryEl);
  }

  /* -------------------------------------------------------
     7. STICKY MOBILE CTA
     Appears after the hero, hides over the final CTA so it
     never covers the section it duplicates.
     ------------------------------------------------------- */
  var sticky = document.getElementById('stickyBar');
  var hero = document.querySelector('.hero');
  var finalCta = document.querySelector('.final');

  if (sticky && window.matchMedia('(max-width: 859px)').matches) {
    sticky.hidden = false;
    document.body.classList.add('has-sticky');

    var pastHero = false;
    var atFinal = false;

    function updateSticky() {
      sticky.classList.toggle('is-visible', pastHero && !atFinal);
    }

    if ('IntersectionObserver' in window) {
      if (hero) {
        new IntersectionObserver(function (entries) {
          pastHero = !entries[0].isIntersecting;
          updateSticky();
        }, { threshold: 0 }).observe(hero);
      }
      if (finalCta) {
        new IntersectionObserver(function (entries) {
          atFinal = entries[0].isIntersecting;
          updateSticky();
        }, { threshold: 0.15 }).observe(finalCta);
      }
    } else {
      sticky.classList.add('is-visible');
    }
  }

  /* -------------------------------------------------------
     8. FOOTER YEAR
     ------------------------------------------------------- */
  var yearEl = document.getElementById('year');
  if (yearEl) yearEl.textContent = String(new Date().getFullYear());
})();
